<template>
    <iframe
        :id="data.id"
        :data-id="'iframe-' + uniqueId"
        :src="data.iframeLink"
        :title="data.title"
        :alt="data.alt"
        :style="data.aspectRatio ? `height: auto; aspect-ratio: ${data.aspectRatio};` : ''"
        width="100%"
        height="420px"
        frameborder="0"
        allowfullscreen
    />
</template>

<script setup>
import iframeResize from "iframe-resizer/js/iframeResizer";

import { defineProps, onMounted } from "vue";

const uniqueId = crypto.randomUUID();

const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
});

onMounted(() => {
    if (!props.data.aspectRatio) {
        document
            .querySelector("[data-id='iframe-" + uniqueId + "']")
            .addEventListener("load", () => {
                iframeResize({ log: true }, "[data-id='iframe-" + uniqueId + "']");
            });
    }
});
</script>
